// extracted by mini-css-extract-plugin
module.exports = {"container":"send-test_container__1vxMV","cross":"send-test_cross__3qCre","popoverContainer":"send-test_popoverContainer__2fFo3"};